module.exports = __webpack_public_path__ + "static/top-companies-2020-a8555376598a49eccd6d0e45a731692d.png";